import React, { useEffect, useRef, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Row,
  Table,
} from "react-bootstrap";
import axios from "axios";
import ReactECharts from "echarts-for-react";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaRedoAlt, FaSyncAlt } from "react-icons/fa";
import { HiMiniViewfinderCircle } from "react-icons/hi2";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Fridgesimg from "../../assets/images/fridgesimg.png";
import Air from "../../assets/images/icons/air.svg";
import Ammonia from "../../assets/images/icons/ammonia.svg";
import Carbon from "../../assets/images/icons/carbon.svg";
import Footprint from "../../assets/images/icons/footprint.svg";
import Humidity from "../../assets/images/icons/humidity.svg";
import Lungs from "../../assets/images/icons/lungs.svg";
import Molecule from "../../assets/images/icons/molecule.svg";
import Nitrogen from "../../assets/images/icons/nitrogen.svg";
import Ozone from "../../assets/images/icons/ozone.svg";
import Temprature from "../../assets/images/icons/temprature.svg";
import liveImage from "../../assets/images/liveimage.svg";
import OzoneLayero3 from "../../assets/images/ozone-layer-o3.svg";
import Sun from "../../assets/images/sun.svg";
import HelperService from "../../Services/HelperService";
import WebService from "../../Services/WebService";
import FullScreenChart from "../FullScreenChart";
import PageTitle from "../PageTitle";
import Meter from "./meter";
import Record from "./Record";
import { PiSealWarning, PiTrash } from "react-icons/pi";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AirText from "../../assets/images/airtext.svg";
import SettingIcon from "../../assets/images/setting.svg";
import DashboardIcon from "../../assets/images/dashboard.svg";
import AsyncSelect from "react-select/async";
import { MdClose } from "react-icons/md";
import { BsSave } from "react-icons/bs";
import NoDataFound from "../../assets/images/empty_item.svg";
export interface WeatherData {
  temperature: string;
  city: string;
  weatherDiscription?: string;
  icon?: string;
}
type RangeType =
  | "Severe"
  | "Very Poor"
  | "Poor"
  | "Moderate"
  | "Good"
  | "Excellent"
  | "Satisfactory";
export interface MeterBadge {
  label: string;
  emoji: string;
  badgeClass: string;
  value: string;
  parameter: string;
  count: number;
  noValue: boolean;
  text: string;
  maxValue: number;
  minValue: number;
}

interface StoredValues {
  indoorSensorId: string;
  outdoorSensorId: string;
  longitude: string;
  lattitude: string;
  siteId: string;
  machineId: string;
  machineType: string;
  companyId: string;
  companyLogo: string;
}

export const MACHINE_TYPE = {
  ULTRAPRO: "ULTRAPRO",
  ULTIMATE: "ULTIMATE",
  VANILA: "VANILA",
};
const CommandCentreNewFlow = (props: any) => {
  const [loader, setLoader] = useState(false);
  const { t } = useTranslation();
  let socket = new WebSocket("wss://apiv2.justbreathe.in/live-data");
  const {
    formState: { errors },
    setValue,
  } = useForm();
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    formState: { errors: errors1 },
    watch: watch1,
    reset: reset1,
    setValue: setValue1,
    setError: setError1,
    clearErrors: clearErrors1,
  } = useForm();
  const [webscocketIndoorData, setWebSocketIndoorData] = useState<any>(null);
  const [webSocketOutdoorData, setWebsocketOutdoorData] = useState<any>(null);
  const [selectedComponent, setSelectedComponent] = useState<any[]>([]);
  const [indoorData, setIndoorData] = useState<any>(null);
  const [outdoorData, setOutdoorData] = useState<any>(null);
  const [stationData, setStationData] = useState<any>(null);
  const [machineData, setMachineData] = useState<any>(null);
  const [liveMachineData, setLiveMachineData] = useState<any>(null);

  const [modalShow, setModalShow] = React.useState(false);
  const [isChartView, setIsChartView] = useState(true);
  const [key, setKey] = useState(1);
  const [key1, setKey1] = useState(3);
  const [stationId, setStationId] = useState("");
  const [relayScreen, setRelayScreen] = useState(false);
  const [relayList, setRelayList] = useState<any[]>([]);
  const participantRef = useRef(null);
  const participantRefRegulate = useRef(null);
  const [selectedParticipants, setSelectedParticipants] = useState<any[]>([]);
  const [selectedParticipantsRegulate, setSelectedParticipantsRegulate] =
    useState<any[]>([]);
  const navigate = useNavigate();
  let params = useParams();
  let machineId = params?.machineId;
  let companyId = params?.companyId;
  let outdoorSensorId = params?.outdoorSensorId;
  let siteId = params?.siteId;
  var relaykey = 0;
  const [stationParameterRangeData, setStationParameterRangeData] =
    useState<any>([]);
  const [indoorSensorStatus, setIndoorSensorStatus] = useState<any>(null);
  const [outdoorSensorStatus, setOutdoorSensorStatus] = useState<any>(null);
  const [showDelete, setShowDelete] = useState(false);
  const [dominantPollutant, setDominantPullutant] = useState("-");
  const [dominant1, setDominant1] = useState("");
  const dropdownValues = [
    { value: "arrAQI7Days", label: "AQI" },
    { value: "arrCoDays", label: "CO" },
    { value: "arrNh3Days", label: "NH3" },
    { value: "arrNo2Days", label: "NO2" },
    { value: "arrO3Days", label: "O3" },
    { value: "arrPM10Days", label: "PM10" },
    { value: "arrPM25Days", label: "PM25" },
  ];
  const [selectedValue, setSelectedValue] = useState({
    value: "arrAQI7Days",
    label: "AQI",
  });
  const [chartData, setChartData] = useState<any>(null);
  const handleCloseDelete = () => {
    setRestartMAchineType("");
    setShowDelete(false);
  };
  // const [outdoorOptionGraphData, SetOutdoorOptionsGraphData] = useState<any>(
  //   {}
  // );
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [showDeleteCard, setShowDeletCard] = useState(false);
  const [PM25IndoorObject, setPM25IndoorObject] = useState<MeterBadge>({
    label: "",
    emoji: "",
    badgeClass: "",
    value: "",
    parameter: "",
    count: 1,
    noValue: true,
    text: "",
    maxValue: 100,
    minValue: 0,
  });
  const [PM25OutdoorObject, setPM25OutdoorObject] = useState<MeterBadge>({
    label: "",
    emoji: "",
    badgeClass: "",
    value: "",
    parameter: "",
    count: 1,
    noValue: true,
    text: "",
    maxValue: 100,
    minValue: 0,
  });
  const [obj, setObj] = useState<any>({
    option1: [],
    option2: [],
    option3: [],
    option4: [],
    option5: [],
    option6: [],
    option7: [],
    option8: [],
    option9: [],
    option10: [],
    option11: [],
  });
  const [obj1, setObj1] = useState<any>({
    option1: [],
    option2: [],
    option3: [],
    option4: [],
    option5: [],
    option6: [],
    option7: [],
    option8: [],
    option9: [],
    option10: [],
    option11: [],
    option12: [],
  });

  const [weatherData, setWeatherData] = useState<WeatherData | null>(() => {
    const storedData = localStorage.getItem("weatherAPIData");
    return storedData ? JSON.parse(storedData) : null;
  });
  const [hasData, setHasData] = useState(true);
  const [randomValues, setRandomValues] = useState([
    "co",
    "co2",
    "nh3",
    "no2",
    "o2",
    "o3",
    "pm1",
    "pm2_5",
    "pm10",
    "tvoc",
    "rh",
    "temperature1",
    "temperature2",
    "so2",
    "lux",
  ]);
  const rangeTypeValues: Record<RangeType, string> = {
    Severe: "😢",
    "Very Poor": "😟",
    Poor: "😞",
    Moderate: "😐",
    Good: "😊",
    Excellent: "😁",
    Satisfactory: "😌",
  };

  const formatOutdoorLabel = (label: any) => {
    switch (label) {
      case "pm2_5":
        return "PM2.5";
      case "pm10":
        return "PM10";
      case "nh3":
        return "NH3";
      case "o2":
        return "O2";
      case "rh":
        return "Relative Humidity";
      case "tvoc":
        return "TVOC";
      case "decibel":
        return "Decibel";
      case "co2":
        return "CO2";
      case "o3":
        return "O3";
      case "co":
        return "CO";
      case "no2":
        return "NO2";
      case "luxlevel":
        return "Lux Level";
      default:
        return label.toUpperCase();
    }
  };
  const prepareGraphData = (paramKey: string) => {
    const indoorData1 = indoorData?.[paramKey] || {};
    const outdoorData1 = outdoorData?.[paramKey] || {};

    const keys = Object.keys(indoorData1)
      .reverse()
      .slice(4, 7)
      .map((key) => moment(key).format("DD-MM-YYYY"));
    const valuesIndoor = Object.values(indoorData1)
      .slice(0, 3)
      .reverse()
      .map((val: any) => parseFloat(Number(val).toFixed(2)));

    const valuesOutdoor = Object.values(outdoorData1)
      .slice(0, 3)
      .reverse()
      .map((val: any) => parseFloat(Number(val).toFixed(2)));

    const { minX, newMaxValue, steps } = getMaxMinValueForGraph(
      valuesIndoor,
      valuesOutdoor
    );

    setChartData({
      grid: { top: 20, right: 30, bottom: 40, left: 50 },
      xAxis: {
        type: "category",
        data: keys,
        axisLabel: {
          rotate: 45,
          formatter: (value: any) => value.split(" ")[0],
          fontSize: 8,
        },
      },
      yAxis: [
        {
          min: minX,
          max: newMaxValue,
          type: "value",
          axisLabel: {
            formatter: (value: any) => Number(value),
            fontSize: 10,
          },
          axisLine: { lineStyle: { color: "#5470C6" } },
        },
        {
          type: "value",
          axisLabel: {
            formatter: (value: any) => Number(value).toFixed(2),
          },
          axisLine: { lineStyle: { color: "#91CC75" } },
          position: "right",
          offset: 30,
        },
      ],
      series: [
        {
          name: "Indoor",
          data: valuesIndoor,
          type: "line",
          smooth: true,
          lineStyle: { width: 1 },
          itemStyle: { color: "#00FF00" },
          animationDuration: 2000,
          animationEasing: "cubicOut",
          yAxisIndex: 0,
        },
        {
          name: "Outdoor",
          data: valuesOutdoor,
          type: "line",
          smooth: true,
          lineStyle: { width: 1 },
          itemStyle: { color: "#FFAA44" },
          animationDuration: 2000,
          animationEasing: "cubicOut",
          yAxisIndex: 1,
        },
      ],
      tooltip: {
        trigger: "axis",
        backgroundColor: "rgba(50, 50, 50, 0.7)",
        borderColor: "#333",
        borderWidth: 1,
        textStyle: { color: "#fff" },
        formatter: (params: any) => {
          let tooltipContent = `${params[0].axisValue}<br/>`;
          params.forEach((item: any) => {
            tooltipContent += `${item.marker} ${item.seriesName}: ${Number(
              item.data
            ).toFixed(2)}<br/>`;
          });
          return tooltipContent;
        },
      },
    });
  };
  const [restartMachineType, setRestartMAchineType] = useState("");
  useEffect(() => {
    getLiveRecentData();
    const intervalId = setInterval(() => {
      getRecentData(stationParameterRangeData);
    }, 60000);

    return () => clearInterval(intervalId);
  }, []);

  let DASHBOARD_BASE_URL = "https://dashboard.justbreathe.in/command-center/";
  const BASE_URL = "https://api.openweathermap.org/";
  const apiKey = "74fc72f9df6e931a1cacc472c29b37b3";

  useEffect(() => {
    if (machineId && companyId && outdoorSensorId) {
      getIndoorData(machineId ?? "");
      getWebsocketView(machineId ?? "", companyId ?? "");
      getStationDetails();
      getRecentDataForIndoorSensor();
      getRecentDataForOutdoorSensor();
    } else {
      window.history.back();
    }
    return () => {
    };
  }, []);
  useEffect(() => {
    getParameterRangeData();
    participantPromiseOptions();
    participantPromiseOptionsRegulate();
  }, []);

  useEffect(() => {
    let role = localStorage.getItem("role");
    if (role === "CLIENT") {
      navigate("/access-denied");
    }
  });

  const getWeatherData = (lat: any, long: any) => {
    const lastFetchDate = localStorage.getItem("weatherDataCollectedDate");
    const currentDate = new Date().toISOString().split("T")[0];
    // if (!lastFetchDate || lastFetchDate !== currentDate) {
    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    return axios
      .get(
        `${BASE_URL}data/2.5/weather?lat=${lat}&lon=${long}&appid=${apiKey}`,
        {
          headers: headers,
        }
      )
      .then((response: any) => {
        let data: WeatherData = {
          temperature: (response?.data?.main?.temp - 273.15).toFixed(2),
          city: response?.data?.name,
          weatherDiscription: response?.data?.weather[0]?.description,
          icon: HelperService.getIconForWeather(
            response?.data?.weather[0]?.icon
          ),
        };
        localStorage.setItem("weatherDataCollectedDate", currentDate);
        localStorage.setItem("weatherAPIData", JSON.stringify(data));
        setWeatherData(data);
      })
      .catch((error: any) => { });
    // }
  };

  const getWebsocketView = (machineId: string, companyId: string) => {
    socket.onopen = function () {

      // Subscribe to a topic
      socket.send(
        JSON.stringify({
          action: "init",
          topic: machineId + "-c",
        })
      );
      socket.send(
        JSON.stringify({
          action: "subscribe",
          topic: `Devices/M2C/ST_${companyId}_${machineId}/stationData`,
        })
      );

      // Outdoor
      socket.send(
        JSON.stringify({
          action: "subscribe",
          topic: `Devices/M2C/OD_${outdoorSensorId}/airScopeDataOutdoor`,
        })
      );

      // airscope data
      socket.send(
        JSON.stringify({
          action: "subscribe",
          topic: `Devices/M2C/ST_${companyId}_${machineId}/airScopeData`,
        })
      );

      //Indoor triggers
      socket.send(
        JSON.stringify({
          action: "subscribe",
          topic: `Devices/M2C/ST_${companyId}_${machineId}/triggers`,
        })
      );

      // Outdoor triggers
      socket.send(
        JSON.stringify({
          action: "subscribe",
          topic: `Devices/M2C/OD_${outdoorSensorId}/triggers`,
        })
      );

      socket.onmessage = (event: any) => {
        let data = JSON.parse(event?.data);

        if (
          data?.topic ===
          `Devices/M2C/ST_${companyId}_${machineId}/airScopeData`
        ) {
          setWebSocketIndoorData(JSON.parse(data?.content));
        }
        if (
          data.topic === `Devices/M2C/OD_${outdoorSensorId}/airScopeDataOutdoor`
        ) {
          setWebsocketOutdoorData(JSON.parse(data?.content));
        }

        if (
          data.topic === `Devices/M2C/ST_${companyId}_${machineId}/stationData`
        ) {
          let parsedData = JSON.parse(data?.content);
          setMachineData(parsedData);
        }

        if (data?.topic === `Devices/M2C/ST_${companyId}_${machineId}/triggers`) {
          let parsedData = JSON.parse(data?.content);
          if (parsedData?.restart === 1) {
            getIndoorRestartData();
          }
        }

        if (data?.topic === `Devices/M2C/OD_${outdoorSensorId}/triggers`) {
          let parsedData = JSON.parse(data?.content);
          if (parsedData?.restart === 1) {
            getOutdoorRestartData();
          }
        }

        socket.onclose = function () {
        };
      };
    };
  };
  useEffect(() => {
    if (indoorData) {
      prepareGraphData(selectedValue.value);
    }
  }, [indoorData]);

  const getIndoorRestartData = () => {
    WebService.getAPI({
      action: `command-centre/station/restart?station_id=${machineId}`,
      body: null,
    })
      .then((res: any) => {
      }).catch((error: any) => {
      });
  }

  const getOutdoorRestartData = () => {
    WebService.getAPI({
      action: `command-centre/station/sensor/restart?station_id=${machineId}`,
      body: null,
    })
      .then((res: any) => {
      }).catch((error: any) => {
      });
  }

  const getIndoorData = (stationId: string) => {
    setLoader(true);
    return WebService.getAPI({
      action: `iot/dashboard?stationId=${stationId}`,
      body: null,
    })
      .then((res: any) => {
        setIndoorData(res?.indoor);
        setOutdoorData(res?.outdoor);

        const keys = Object.keys(res?.indoor?.arrAQI7Days || {})
          .reverse()
          .slice(4, 7)
          .map((key) => moment(key).format("DD-MM-YYYY"));

        const valuesIndoor = Object.values(res?.indoor?.arrAQI7Days)
          .slice(0, 3)
          .reverse();

        const valuesOutdoor = Object.values(res?.outdoor?.arrAQI7Days)
          .slice(0, 3)
          .reverse();
        let { minX, newMaxValue, steps } = getMaxMinValueForGraph(
          valuesIndoor,
          valuesOutdoor
        );
        // SetOutdoorOptionsGraphData({
        //   grid: { top: 20, right: 30, bottom: 40, left: 50 },
        //   xAxis: {
        //     type: "category",
        //     data: keys,
        //     axisLabel: {
        //       rotate: 45,
        //       formatter: (value: any) => value.split(" ")[0],
        //       fontSize: 8,
        //     },
        //   },
        //   yAxis: [
        //     {
        //       min: minX,
        //       max: newMaxValue,
        //       stepSize: steps,

        //       type: "value",
        //       axisLabel: {
        //         formatter: "{value}",
        //         fontSize: 10,
        //       },

        //       axisLine: {
        //         lineStyle: {
        //           color: "#5470C6",
        //         },
        //       },
        //     },
        //     {
        //       type: "value",
        //       axisLabel: {
        //         formatter: "{value}",
        //       },
        //       axisLine: {
        //         lineStyle: {
        //           color: "#91CC75",
        //         },
        //       },
        //       position: "right", // Position the second y-axis on the right
        //       offset: 30, // Offset to avoid overlap with the first y-axis
        //     },
        //   ],
        //   series: [
        //     {
        //       name: "Indoor",
        //       data: valuesIndoor,
        //       type: "line",
        //       smooth: true,
        //       lineStyle: {
        //         width: 1,
        //       },
        //       itemStyle: {
        //         color: "#00FF00",
        //       },
        //       animationDuration: 2000,
        //       animationEasing: "cubicOut",
        //       yAxisIndex: 0,
        //     },
        //     {
        //       name: "Outdoor",
        //       data: valuesOutdoor,
        //       type: "line",
        //       smooth: true,
        //       lineStyle: {
        //         width: 1,
        //       },
        //       itemStyle: {
        //         color: "#FFAA44",
        //       },
        //       animationDuration: 2000, // Animation duration in milliseconds
        //       animationEasing: "cubicOut", // Animation easing function
        //       yAxisIndex: 1, // Link to the second y-axis
        //     },
        //   ],
        //   tooltip: {
        //     trigger: "axis",
        //     backgroundColor: "rgba(50, 50, 50, 0.7)", // Customize tooltip background
        //     borderColor: "#333", // Customize tooltip border color
        //     borderWidth: 1, // Customize tooltip border width
        //     textStyle: {
        //       color: "#fff", // Customize tooltip text color
        //     },
        //   },
        // });
        setLoader(false);
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        setLoader(false);
        return null;
      });
  };
  const getMaxMinValueForGraph = (arr1: any[], arr2: any[]) => {
    const values = [...arr1, ...arr2];
    const minX = 0;
    const maxX = Math.max(...values);

    if (maxX === 0) {
      return {
        minX: 0,
        newMaxValue: 1,
        steps: [0, 0.2, 0.4, 0.6, 0.8, 1],
      };
    }

    // Determine a suitable step size based on the max value
    let stepSize: number;
    if (maxX <= 1) stepSize = 0.2;
    else if (maxX <= 2) stepSize = 0.4;
    else if (maxX <= 5) stepSize = 1;
    else if (maxX <= 10) stepSize = 2;
    else if (maxX <= 50) stepSize = 5;
    else if (maxX <= 100) stepSize = 10;
    else stepSize = 20;

    const newMaxValue = Math.ceil(maxX / stepSize) * stepSize;
    const stepCount = 5;
    const partition = newMaxValue / stepCount;

    const steps = Array.from({ length: stepCount + 1 }, (_, i) =>
      parseFloat((i * partition).toFixed(2))
    );

    return { minX, newMaxValue, steps };
  };

  const getStationDetails = () => {
    setLoader(true);
    WebService.getAPI({
      action: `command-centre/station/detail?station_id=${machineId}`,
      body: null,
    })
      .then((res: any) => {
        setLoader(false);
        setStationData(res.result);
        getWeatherData(res.result.latitude, res.result.longitude);
        setValue("outdoorSensorId", res.result.outdoorSensorId);
      })
      .catch((error: any) => {
        setLoader(false);
        return false;
      });
  };

  const getRecentDataForOutdoorSensor = () => {
    setLoader(true);
    WebService.getAPI({
      action: `command-centre/outdoor-sensor/status?station_id=${machineId}`,
      body: null,
    })
      .then((res: any) => {
        setLoader(false);
        setOutdoorSensorStatus(res.result);
      })
      .catch((error: any) => {
        setLoader(false);
        return false;
      });
  };
  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = dropdownValues.find(
      (item) => item.value === e.target.value
    );

    if (selected) {
      setSelectedValue(selected);
      const indoorData1 = indoorData?.[selected.value];
      if (!indoorData1) {
        setHasData(false);
        setChartData({
          grid: { top: 20, right: 30, bottom: 40, left: 50 },
          xAxis: {
            type: "category",
            data: ["--", "--", "--"], // placeholder dates
            axisLabel: { rotate: 45, fontSize: 8 },
          },
          yAxis: [
            { type: "value", min: 0, max: 10, axisLabel: { fontSize: 10 } },
            { type: "value", position: "right", offset: 30 },
          ],
          series: [
            {
              name: "Indoor",
              data: [0, 0, 0],
              type: "line",
              smooth: true,
              itemStyle: { color: "#00FF00" },
              yAxisIndex: 0,
            },
            {
              name: "Outdoor",
              data: [0, 0, 0],
              type: "line",
              smooth: true,
              itemStyle: { color: "#FFAA44" },
              yAxisIndex: 1,
            },
          ],
          tooltip: { trigger: "axis" },
        });
      } else {
        setHasData(true);
        prepareGraphData(selected.value);
      }
    }
  };

  const getRecentDataForIndoorSensor = () => {
    setLoader(true);
    WebService.getAPI({
      action: `command-centre/indoor-sensor/status?station_id=${machineId}`,
      body: null,
    })
      .then((res: any) => {
        setLoader(false);
        setIndoorSensorStatus(res.result);
      })
      .catch((error: any) => {
        setLoader(false);
        return false;
      });
  };

  const handleRefreshData = () => {

    WebService.getAPI({
      action: `command-centre/station/refresh?station_id=${machineId}`,
      body: null,
    })
      .then((res: any) => {
        toast.success(res.message);
      })
      .catch((error: any) => {
        return false;
      });
  };

  const handleIndoorRestartData = () => {
    WebService.getAPI({
      action: `command-centre/station/restart?station_id=${machineId}`,
      body: null,
    })
      .then((res: any) => {
        toast.success(res.message);
        getStationDetails();
        handleCloseDelete();
      })
      .catch((error: any) => {
        return false;
      });
  };

  const handleOutdoorRestartData = () => {
    WebService.getAPI({
      action: `command-centre/station/sensor/restart?station_id=${machineId}`,
      body: null,
    })
      .then((res: any) => {
        toast.success(res.message);
        handleCloseDelete();
        getStationDetails();
      })
      .catch((error: any) => {
        return false;
      });
  };

  let temperature1 = webscocketIndoorData?.temperature1 ?? 0;
  let temperature2 = webscocketIndoorData?.temperature2 ?? 0;
  let lowestTemperature = Math.min(temperature1, temperature2);

  let outdoorTemperature1 = webSocketOutdoorData?.temperature1 ?? 0;
  let outdoorTemperature2 = webSocketOutdoorData?.temperature2 ?? 0;
  let outdoorLowestTemperature = Math.min(
    outdoorTemperature1,
    outdoorTemperature2
  );

  const getGaugeChartPercent = (value: any, range: any) => {
    if (value > range?.toRange) {
      return 1;
    }
    return value / 100;
  };

  const getGaugeChartColor = (value: any, range: any) => {
    if (value > range?.toRange) {
      return "red";
    }
    return value > range.fromRange ? "orange" : "green";
  };

  const getParameterRangeData = () => {
    const body = {
      site_id: siteId ?? "",
    };
    var queryParam = new URLSearchParams(body);
    return WebService.getAPI({
      action: `parameter-range?` + queryParam,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        setStationParameterRangeData(res.list);
        getRecentData(res?.list);
      })
      .catch((error: any) => {
        return error;
      });
  };
  const getRecentData = (localParameterList: any) => {
    return WebService.getAPI({
      action: `station/most-recent-data?station_id=${machineId}`,
      body: null,
    })
      .then((res: any) => {
        getGaugeChartObject(
          res?.result?.indoorSensorData,
          res?.result?.outdoorSensorData,
          localParameterList
        );
        if (dominant1) {
          let dominant = HelperService.formatLabel(dominant1);
          let dominantPollutantValue = res?.result?.indoorSensorData[dominant];
          if (
            checkDominantPollutantRange(
              dominant,
              dominantPollutantValue,
              localParameterList
            )
          )
            setDominantPullutant("-");
          else setDominantPullutant(indoorData?.dominantPollutant);
        } else {
          setDominantPullutant("-");
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return null;
      });
  };

  const getLiveRecentData = () => {
    return WebService.getAPI({
      action: `station/recent-live-data?station_id=${machineId}`,
      body: null,
    })
      .then((res: any) => {
        setLiveMachineData(res?.result);
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return null;
      });
  };

  const checkDominantPollutantRange = (
    dominant: any,
    dominantValue: any,
    parameterListLocal: any
  ) => {
    if (parameterListLocal && parameterListLocal?.length > 0) {
      if (parameterListLocal && parameterListLocal.length > 0) {
        let matched = false;

        for (let item of parameterListLocal) {
          const { parameterName, fromRange, toRange, rangeType } = item;

          if (
            parameterName.toLowerCase() === dominant.toLowerCase() &&
            dominantValue >= fromRange &&
            dominantValue <= toRange &&
            (rangeType === "Excellent" || rangeType === "Good")
          ) {
            matched = true;
          }
        }
        return matched;
      }
    }
    return true;
  };
  const getGaugeChartObject = (
    recentIndoorData: any,
    recentOutdoorData: any,
    parameterListLocal: any[]
  ) => {
    let parameter =
      randomValues[Math.floor(Math.random() * randomValues.length)];

    let indoorValue1 =
      recentIndoorData &&
      recentIndoorData[parameter] &&
      Number(recentIndoorData[parameter]);
    let outdoorValue1 =
      recentOutdoorData &&
      recentOutdoorData[parameter] &&
      Number(recentOutdoorData[parameter]);

    let indoorValue = indoorValue1?.toFixed(0);
    let outdoorValue = outdoorValue1?.toFixed(0);

    if (parameterListLocal && parameterListLocal.length > 0) {
      const count = parameterListLocal.filter(
        (record) =>
          record.parameterName.toLowerCase() === parameter.toLowerCase()
      ).length;

      let matched = false;
      let matched1 = false;

      for (let item of parameterListLocal) {
        const {
          parameterName,
          fromRange,
          toRange,
          rangeType,
          rangeColorInHex,
          maximumValue,
          minimumValue,
        } = item;

        if (
          parameterName.toLowerCase() === parameter.toLowerCase() &&
          indoorValue >= fromRange &&
          indoorValue <= toRange
        ) {
          matched = true;
          if (parameter === "temperature1" || parameter === "temperature2") {
            const temp1 = recentIndoorData["temperature1"];
            const temp2 = recentIndoorData["temperature2"];

            if (temp1 < temp2) {
              parameter = "temperature";
              indoorValue = temp1.toFixed(0);
            } else {
              parameter = "temperature";
              indoorValue = temp2.toFixed(0);
            }
          }
          let obj = {
            label: rangeType,
            emoji: rangeTypeValues[rangeType as RangeType],
            badgeClass: rangeColorInHex,
            parameter: parameter ?? "",
            value: HelperService.formatNumber(indoorValue).toString(),
            count: count,
            noValue: false,
            maxValue: maximumValue,
            minValue: minimumValue,
            text:
              parameter === "temperature" && indoorValue < outdoorValue
                ? "Indoor Temperature quality is more better than the Outdoor"
                : parameter === "temperature" && indoorValue > outdoorValue
                  ? "Outdoor Temperature quality is more better than the Indoor"
                  : parameter === "temperature" && indoorValue === outdoorValue
                    ? "Indoor and Outdoor both Temperature Quality are better"
                    : indoorValue === outdoorValue
                      ? "Indoor and Outdoor both Air Quality are better"
                      : indoorValue > outdoorValue
                        ? "Outdoor air quality is more better than the Indoor"
                        : "Indoor air quality is more better than the Outdoor",
          };
          setPM25IndoorObject(obj);
          setKey(Math.random());
          break;
        }
      }
      for (let item of parameterListLocal) {
        const {
          parameterName,
          fromRange,
          toRange,
          rangeType,
          rangeColorInHex,
          maximumValue,
          minimumValue,
        } = item;
        if (
          parameterName.toLowerCase() === parameter.toLowerCase() &&
          outdoorValue >= fromRange &&
          outdoorValue <= toRange
        ) {
          matched1 = true;

          if (parameter === "temperature1" || parameter === "temperature2") {
            const temp1 = recentOutdoorData["temperature1"];
            const temp2 = recentOutdoorData["temperature2"];

            if (temp1 < temp2) {
              parameter = "temperature";
              outdoorValue = temp1;
            } else {
              parameter = "temperature";
              outdoorValue = temp2;
            }
          }
          setPM25OutdoorObject({
            label: rangeType,
            emoji: rangeTypeValues[rangeType as RangeType],
            badgeClass: rangeColorInHex,
            parameter: parameter ?? "",
            value: outdoorValue
              ? HelperService.formatNumber(outdoorValue)?.toString()
              : "0",
            count: count,
            noValue: false,
            text: "",
            maxValue: maximumValue,
            minValue: minimumValue,
          });
          setKey1(Math.random());
          break;
        }
      }

      if (!matched) {
        setPM25IndoorObject({
          label: "Very Poor",
          emoji: rangeTypeValues["Very Poor"],
          badgeClass: "#cc3232",
          parameter: parameter ?? "",
          value: indoorValue
            ? HelperService.formatNumber(indoorValue).toString()
            : "0",
          noValue: true,
          count: 1,
          maxValue: 100,
          text: "",
          minValue: 0,
        });
        setKey(Math.random());
      }

      if (!matched1) {
        setPM25OutdoorObject({
          label: "Very Poor",
          emoji: rangeTypeValues["Very Poor"],
          badgeClass: "#cc3232",
          parameter: parameter ?? "",
          value: outdoorValue
            ? HelperService.formatNumber(outdoorValue)?.toString()
            : "0",
          noValue: true,
          count: 1,
          text: "",
          maxValue: 100,
          minValue: 0,
        });
        setKey1(Math.random());
      }
    }
  };
  // const getGaugeChartObject = (
  //   recentIndoorData: any,
  //   recentOutdoorData: any,
  //   parameterListLocal: any[]
  // ) => {
  //   let parameter =
  //     randomValues[Math.floor(Math.random() * randomValues.length)];
  //   let indoorValue = recentIndoorData[parameter];
  //   let outdoorValue = recentOutdoorData[parameter];

  //   if (parameterListLocal && parameterListLocal.length > 0) {
  //     const count = parameterListLocal.filter(
  //       (record) =>
  //         record.parameterName.toUpperCase() === parameter.toUpperCase()
  //     ).length;

  //     let matched = false;
  //     let matched1 = false;

  //     for (let item of parameterListLocal) {
  //       const {
  //         parameterName,
  //         fromRange,
  //         toRange,
  //         rangeType,
  //         rangeColorInHex,
  //       } = item;

  //       if (
  //         parameterName.toUpperCase() === parameter.toUpperCase() &&
  //         indoorValue >= fromRange &&
  //         indoorValue <= toRange
  //       ) {
  //         matched = true;
  //         if (parameter === "temperature1" || parameter === "temperature2") {
  //           const temp1 = recentIndoorData["temperature1"];
  //           const temp2 = recentIndoorData["temperature2"];

  //           if (temp1 < temp2) {
  //             parameter = "temperature";
  //             indoorValue = temp1;
  //           } else {
  //             parameter = "temperature";
  //             indoorValue = temp2;
  //           }
  //         }
  //         setPM25IndoorObject({
  //           label: rangeType ?? "",
  //           emoji: rangeTypeValues[rangeType as RangeType],
  //           badgeClass: rangeColorInHex,
  //           parameter: parameter ?? "",
  //           value: indoorValue ?? 0,
  //           count: count,
  //           noValue: false,
  //         });
  //         setKey(Math.random());
  //         break;
  //       }
  //     }
  //     for (let item of parameterListLocal) {
  //       const {
  //         parameterName,
  //         fromRange,
  //         toRange,
  //         rangeType,
  //         rangeColorInHex,
  //       } = item;

  //       if (
  //         parameterName.toUpperCase() === parameter.toUpperCase() &&
  //         outdoorData >= fromRange &&
  //         outdoorData <= toRange
  //       ) {
  //         matched1 = true;

  //         if (parameter === "temperature1" || parameter === "temperature2") {
  //           const temp1 = recentOutdoorData["temperature1"];
  //           const temp2 = recentOutdoorData["temperature2"];

  //           if (temp1 < temp2) {
  //             parameter = "temperature";
  //             outdoorValue = temp1;
  //           } else {
  //             parameter = "temperature";
  //             outdoorValue = temp2;
  //           }
  //         }
  //         setPM25OutdoorObject({
  //           label: rangeType ?? "",
  //           emoji: rangeTypeValues[rangeType as RangeType],
  //           badgeClass: rangeColorInHex,
  //           parameter: parameter ?? "",
  //           value: outdoorValue ?? 0,
  //           count: count,
  //           noValue: false,
  //         });
  //         setKey1(Math.random());
  //         break;
  //       }
  //     }

  //     if (!matched) {
  //       setPM25IndoorObject({
  //         label: "Poor",
  //         emoji: rangeTypeValues["Poor"],
  //         badgeClass: "#cc3232",
  //         parameter: parameter ?? "",
  //         value: indoorValue ?? 0,
  //         noValue: true,
  //         count: 1,
  //       });
  //       setKey(Math.random());
  //     }

  //     if (!matched1) {
  //       setPM25OutdoorObject({
  //         label: "Poor",
  //         emoji: rangeTypeValues["Poor"],
  //         badgeClass: "#cc3232",
  //         parameter: parameter ?? "",
  //         value: outdoorValue ?? 0,
  //         noValue: true,
  //         count: 1,
  //       });
  //       setKey1(Math.random());
  //     }
  //   }
  // };
  const getGraphdata = (
    value: any,
    indoorDataLocal: any,
    outDoorDatalocal: any
  ) => {
    let valuesIndoor = {};
    let valuesOutdoor = {};
    let keys = {};
    switch (value) {
      case "PM2.5":
        valuesIndoor = Object.values(indoorDataLocal?.arrPm25 || {});
        valuesOutdoor = Object.values(outDoorDatalocal?.arrPm25 || {});
        keys = Object.keys(indoorDataLocal?.arrPm25 || {})
          .map((key) => moment(key).format("DD-MM-YYYY"))
          .sort((a, b) =>
            moment(a, "DD-MM-YYYY").diff(moment(b, "DD-MM-YYYY"))
          );
        setValue("parameter", value);
        break;
      // case "PM1":
      //   valuesIndoor = Object.values(indoorDataLocal?.arrPm1 || {});
      //   valuesOutdoor = Object.values(outDoorDatalocal?.arrPm1 || {});
      //   keys = Object.keys(indoorData?.arrPm1 || {})
      //     .map((key) => moment(key).format("DD-MM-YYYY"))
      //     .sort((a, b) =>
      //       moment(a, "DD-MM-YYYY").diff(moment(b, "DD-MM-YYYY"))
      //     );
      //   setValue("parameter", value);
      //   break;
      default:
        return;
    }

    // SetOutdoorOptionsGraphData({
    //   grid: { top: 20, right: 30, bottom: 40, left: 50 },
    //   xAxis: {
    //     type: "category",
    //     data: keys,
    //     axisLabel: {
    //       rotate: 45,
    //       formatter: (value: any) => value.split(" ")[0],
    //       fontSize: 8,
    //     },
    //   },
    //   yAxis: [
    //     {
    //       type: "value",
    //       axisLabel: {
    //         formatter: "{value}",
    //         fontSize: 10,
    //       },
    //       axisLine: {
    //         lineStyle: {
    //           color: "#5470C6",
    //         },
    //       },
    //     },
    //     {
    //       type: "value",
    //       axisLabel: {
    //         formatter: "{value}",
    //       },
    //       axisLine: {
    //         lineStyle: {
    //           color: "#91CC75",
    //         },
    //       },
    //       position: "right", // Position the second y-axis on the right
    //       offset: 30, // Offset to avoid overlap with the first y-axis
    //     },
    //   ],
    //   series: [
    //     {
    //       name: "Indoor",
    //       data: valuesIndoor,
    //       type: "line",
    //       smooth: true,
    //       lineStyle: {
    //         width: 1,
    //       },
    //       itemStyle: {
    //         color: "#32CD32",
    //       },
    //       animationDuration: 2000,
    //       animationEasing: "cubicOut",
    //       yAxisIndex: 0,
    //     },
    //     {
    //       name: "Outdoor",
    //       data: valuesOutdoor,
    //       type: "line",
    //       smooth: true,
    //       lineStyle: {
    //         width: 1,
    //       },
    //       itemStyle: {
    //         color: "#FFA500",
    //       },
    //       animationDuration: 2000, // Animation duration in milliseconds
    //       animationEasing: "cubicOut", // Animation easing function
    //       yAxisIndex: 1, // Link to the second y-axis
    //     },
    //   ],
    //   tooltip: {
    //     trigger: "axis",
    //     backgroundColor: "rgba(50, 50, 50, 0.7)", // Customize tooltip background
    //     borderColor: "#333", // Customize tooltip border color
    //     borderWidth: 1, // Customize tooltip border width
    //     textStyle: {
    //       color: "#fff", // Customize tooltip text color
    //     },
    //   },
    // });
  };
  const getColorCode = (
    value: number,
    parameter: string,
    parameterListLocal: any[]
  ) => {
    if (parameterListLocal && parameterListLocal.length > 0) {
      for (let item of parameterListLocal) {
        const { parameterName, fromRange, toRange, rangeColorInHex } = item;

        if (
          parameterName.toUpperCase() === parameter.toUpperCase() &&
          value >= fromRange &&
          value <= toRange
        ) {
          return rangeColorInHex;
        }
      }
      // changeGraphColor(parameter.toUpperCase(), "#cc3232");
      return "#cc3232";
    } else {
      // changeGraphColor(parameter.toUpperCase(), "#cc3232");
      return "#cc3232";
    }
  };

  const handleDeleteCommandCentreData = () => {
    let deleteStartDate = moment(startDate).format("DD-MM-YYYY HH:mm");
    let deleteEndDate = moment(endDate).format("DD-MM-YYYY HH:mm");
    WebService.addLoader("deleteButton");
    WebService.deleteAPI({
      action: `command-centre/delete-data?start_date=${deleteStartDate}&end_date=${deleteEndDate}&station_id=${machineId}&appLang`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        WebService.removeLoader("deleteButton");
        toast.success(res.message);
        setShowDeletCard(false);
      })
      .catch((error: any) => {
        WebService.removeLoader("deleteButton");
        return false;
      });
  };

  const handleRestartMachine = () => {
    if (restartMachineType === "INDOOR") handleIndoorRestartData();
    else if (restartMachineType === "OUTDOOR") handleOutdoorRestartData();
  };

  const HandleRelay = (id: any) => {
    setStationId(id);
    setRelayScreen(true);
    return WebService.getAPI({
      action: `relays?page=1&order_by=ASC&sort_by=id&station_id=${id}`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        relaykey = relaykey + 1;
        setLoader(false);
        setRelayList(res.list);
      })
      .catch((error) => {
        setLoader(false);
        return error;
      });
  };

  useEffect(() => {
    if (relayScreen) {
      const intervalId = setInterval(() => {
        HandleRelay(stationId);
      }, 30000);

      return () => clearInterval(intervalId);
    }
  }, [relayScreen]);

  const handleSave = async (e: any) => {
    const payload = transformDataForApi();
    await saveRelayComponent1(payload);
  };

  const transformDataForApi = () => {
    return {
      stationId: stationId,
      relayRequests: relayList.map((item) => ({
        id: item.id,
        relayValue: item.relayValue,
        relayCode: item.relayCode,
      })),
    };
  };

  const saveRelayComponent1 = async (payload: any) => {
    try {
      const transformedComponents = selectedComponent.map((ele: any) => ({
        id: ele.value,
        label: ele.label,
      }));

      setSelectedComponent(transformedComponents);

      setLoader(true);
      WebService.addLoader("saveRelay");
      const body = {
        stationId: stationId,
        relayRequests: relayList.map((list: any) => ({
          id: list.id,
          relayValue: list.relayValue,
          relayCode: list.relayCode,
          enabled: list.enabled,
          working: list.working,
        })),
      };
      await WebService.putAPI({
        action: `relay/list`,
        body: body,
        isShowError: true,
      })
        .then((res: any) => {
          setLoader(false);
          WebService.removeLoader("saveRelay");
          toast.success(res.message);
        })
        .catch((error) => {
          setLoader(false);
          WebService.removeLoader("saveRelay");
          return error;
        });
    } catch (error) {
      setLoader(false);
      WebService.removeLoader("saveRelay");
      return error;
    }
  };

  const onEnabledSelect = (value: any, id: any) => {
    const updatedRelayList = [...relayList];
    updatedRelayList.map((itm: any) => {
      if (itm.id === id) {
        itm.enabled = value;
      }
    });
    setRelayList(updatedRelayList);
  };

  const handleInputChange = (value: any, id: any) => {
    // Update state with new relay values
    setRelayList((prevList) =>
      prevList.map((item) =>
        item.id === id ? { ...item, relayValue: value } : item
      )
    );
  };

  const onWorkingSelect = (value: any, id: any) => {
    const updatedRelayList = [...relayList];
    updatedRelayList.map((itm: any) => {
      if (itm.id === id) {
        itm.working = value;
      }
    });
    setRelayList(updatedRelayList);
  };

  const getColorClass = (value: any) => {
    switch (value) {
      case 1:
        return "green";
      case 0:
        return "grey";
      case -1:
        return "red";
      default:
        return "";
    }
  };

  const onParticipantSelectionRegulate = (
    selectedOption: any,
    index: any,
    id: any
  ) => {
    // if(relayName === "relay1Regulate" || relayName === "relay2Regulate")
    const updatedSelections = [...selectedParticipantsRegulate];
    if (selectedOption === null) {
      updatedSelections[index] = null;
    } else {
      updatedSelections[index] = selectedOption;
    }
    setSelectedParticipantsRegulate(updatedSelections);

    const updatedSelections1 = [...relayList];
    updatedSelections1.map((itm) => {
      if (itm.id === id) {
        itm.relayCode = selectedOption ? selectedOption.value : null;
      }
    });
    setRelayList(updatedSelections1);
  };

  const getAvailableOptions = (index: any) => {
    const selectedValues = selectedParticipants.map((option) => option?.value);

    return obj[`option${index + 1}`]?.filter(
      (option: any) => !selectedValues.includes(option.value)
    );
  };

  const getAvailableOptionsRegulate = (index: any) => {
    const selectedValues = selectedParticipantsRegulate.map(
      (option) => option?.value
    );

    return obj1[`option${index + 1}`]?.filter(
      (option: any) => !selectedValues.includes(option.value)
    );
  };

  const participantPromiseOptions = () =>
    new Promise<any[]>((resolve) => {
      return WebService.getAPI({
        action: `relay/component?order_by=DESC&sort_by=id&keyword`,
      })
        .then((res: any) => {
          if (res?.list?.length > 0) {
            let pagesOptions: any[] = [];
            res.list.map((relayCode: any, page: any) => {
              var object = {
                //   "value": options,
                //   "label": options
                value: relayCode.relayCode,
                label: relayCode.relayCode,
              };
              pagesOptions.push(object);
            });
            let obj = {
              option1: pagesOptions,
              option2: pagesOptions,
              option3: pagesOptions,
              option4: pagesOptions,
              option5: pagesOptions,
              option6: pagesOptions,
              option7: pagesOptions,
              option8: pagesOptions,
              option9: pagesOptions,
              option10: pagesOptions,
              option11: pagesOptions,
            };
            setObj(obj);
          }
        })
        .catch((error: any) => {
          return error;
        });
    });
  const onParticipantSelection = (selectedOption: any, index: any, id: any) => {
    // if(relayName === "relay1Regulate" || relayName === "relay2Regulate")
    const updatedSelections = [...selectedParticipants];
    if (selectedOption === null) {
      updatedSelections[index] = null;
    } else {
      updatedSelections[index] = selectedOption;
    }
    setSelectedParticipants(updatedSelections);

    const updatedSelections1 = [...relayList];
    updatedSelections1.map((itm) => {
      if (itm.id === id) {
        itm.relayCode = selectedOption ? selectedOption.value : null;
      }
    });
    setRelayList(updatedSelections1);
  };

  const participantPromiseOptionsRegulate = () => {
    return WebService.getAPI({
      action: `input/relay/component?`,
    })
      .then((res: any) => {
        if (res?.list?.length > 0) {
          let pagesOptions: any[] = [];
          res.list.map((relayCode: any, page: any) => {
            var object = {
              value: relayCode.relayCode,
              label: relayCode.relayCode,
            };
            pagesOptions.push(object);
          });
          let obj1 = {
            option1: pagesOptions,
            option2: pagesOptions,
            option3: pagesOptions,
            option4: pagesOptions,
            option5: pagesOptions,
            option6: pagesOptions,
            option7: pagesOptions,
            option8: pagesOptions,
            option9: pagesOptions,
            option10: pagesOptions,
            option11: pagesOptions,
            option12: pagesOptions,
          };
          setObj1(obj1);
        }
      })
      .catch((error: any) => {
        return error;
      });
  };

  const storeValuesInLocalStorage = async () => {
    let obj: StoredValues = {
      indoorSensorId: stationData?.indoorSensorId,
      outdoorSensorId: stationData?.outdoorSensorId,
      longitude: stationData?.longitude,
      lattitude: stationData?.lattitude,
      siteId: stationData?.siteId,
      machineId: stationData?.id,
      machineType: stationData?.dashboardType,
      companyId: stationData?.companyId,
      companyLogo: stationData?.companyLogo,
    };

    await localStorage.setItem(
      `machine_data_${obj?.machineId}`,
      JSON.stringify(obj)
    );
    handleNavigation(stationData);
  };

  const handleNavigation = (station: any) => {

    let selectedSitedId = station?.siteId;
    let companyId = station?.companyId;
    let stationId = station?.id;
    let outdoorSensorId = station?.outdoorSensorId;
    let machineType = station?.dashboardType;

    if (
      selectedSitedId &&
      companyId &&
      stationId &&
      outdoorSensorId &&
      machineType
    ) {

      if (machineType === MACHINE_TYPE.ULTIMATE) {
        window.open(
          `${DASHBOARD_BASE_URL}dashboard-ultimate/${selectedSitedId}/${companyId}/${stationId}/${outdoorSensorId}`,
          "_blank"
        );
      } else if (machineType === MACHINE_TYPE.VANILA)
        window.open(
          `${DASHBOARD_BASE_URL}dashboard-vanilla/${selectedSitedId}/${companyId}/${stationId}/${outdoorSensorId}`
        );
      else if (machineType === MACHINE_TYPE.ULTRAPRO)
        window.open(
          `${DASHBOARD_BASE_URL}dashboard-ultrapro/${selectedSitedId}/${companyId}/${stationId}/${outdoorSensorId}`,
          "_blank"
        );
    } else {
    }
  };

  return (
    <>
      <Row>
        <Col>
          <div
            className="justify-content-between align items-center mb-3"
            style={{ display: "flex" }}
          >
            <PageTitle Title={t("Station_Details")} />
            <div>
              <img
                src={SettingIcon}
                alt=""
                title="Setting"
                sizes="25"
                style={{
                  height: "30px",
                  width: "30px",
                  cursor: "pointer",
                  marginRight: "30px",
                }}
                onClick={() => {
                  HandleRelay(machineId);
                }}
              />
              <img
                src={DashboardIcon}
                title="View Dashboard"
                sizes="25"
                style={{
                  height: "30px",
                  width: "30px",
                  cursor: "pointer",
                  marginRight: "30px",
                }}
                onClick={() => {
                  storeValuesInLocalStorage();
                }}
              />

              <Button
                className="btn-sm"
                type="button"
                id="save"
                style={{
                  height: "30px",
                  width: "70px",
                  cursor: "pointer",
                  marginRight: "20px",
                }}
                onClick={() => handleRefreshData()}
              >
                Refresh
              </Button>

              {/* <FaSyncAlt
                style={{
                  height: "30px",
                  width: "30px",
                  cursor: "pointer",
                  marginRight: "30px",
                }}
                title="Refresh Page"
                onClick={() => handleRefreshData()}
              /> */}

              <PiTrash
                style={{ height: "35px", width: "35px", cursor: "pointer" }}
                className="icon"
                title="Delete Record"
                onClick={() => setShowDeletCard(true)}
              />
            </div>
          </div>
        </Col>
      </Row>

      <Modal show={showDeleteCard} onHide={() => setShowDeletCard(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="text-center"></Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <h4>
            <b>Delete Data</b>
          </h4>
          <p>Please select the period for which you want to delete</p>
          <div className="d-flex gap-2">
            <div className="form-group">
              <DatePicker
                selected={startDate}
                dateFormat={"dd/MM/yyyy hh:mm a"}
                showTimeSelect
                onChange={(date: any) => setStartDate(date)}
              />
            </div>
            <div className="d-flex align-items-center">To</div>
            <div className="">
              <DatePicker
                dateFormat={"dd/MM/yyyy hh:mm a"}
                showTimeSelect
                selected={endDate}
                onChange={(date: any) => setEndDate(date)}
              />
            </div>
          </div>
          <br></br>{" "}
          <Button
            variant="primary"
            onClick={() => {
              setEndDate(new Date());
              setStartDate(new Date());
              handleDeleteCommandCentreData();
            }}
            className="btn-lg px-4"
            id="deleteButton"
          >
            Delete
          </Button>
        </Modal.Body>
      </Modal>

      <div className="commandCentre-page mb-4">
        <Row className="g-3">
          <Col lg={5} sm={5}>
            <Row className="g-3">
              <Col lg={6} sm={6}>
                <div className="white-card-box position-relative">
                  <div className="mb-2 d-flex justify-content-between align-items-center">
                    <strong>Indoor Data</strong>
                    <img src={liveImage} width="38" alt="Logo" />

                    <Button
                      className="btn-sm"
                      type="submit"
                      id="save"
                      onClick={() => {
                        setRestartMAchineType("INDOOR");
                        setShowDelete(true);
                      }}
                    >
                      Restart
                    </Button>
                    {/* <FaRedoAlt
                      style={{
                        height: "18px",
                        width: "18px",
                        position: "absolute",
                        right: "10px",
                        cursor: "pointer",
                      }}
                      title="Restart"
                      onClick={handleIndoorRestartData}
                    /> */}
                  </div>
                  <Row className="g-1">
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        logo={Lungs}
                        websocketData={webscocketIndoorData?.pm1}
                        dbRecentData={indoorData?.livePm1}
                        unit="µg/m³"
                        fontColor={getColorCode(
                          webscocketIndoorData?.pm1
                            ? webscocketIndoorData?.pm1
                            : indoorData?.livePm1,
                          "PM1",
                          stationParameterRangeData
                        )}
                        pointer="PM 1"
                        backgroundColor={
                          indoorSensorStatus?.asdpms == 0 ||
                            indoorSensorStatus?.asdpms == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        logo={Lungs}
                        websocketData={webscocketIndoorData?.pm2_5}
                        dbRecentData={indoorData?.livePm25}
                        unit="μg/m³"
                        pointer="PM 2.5"
                        fontColor={getColorCode(
                          webscocketIndoorData?.pm2_5
                            ? webscocketIndoorData?.pm2_5
                            : indoorData?.livePm25,
                          "pm2_5",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdpms == 0 ||
                            indoorSensorStatus?.asdpms == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        logo={Air}
                        websocketData={webscocketIndoorData?.pm10}
                        dbRecentData={indoorData?.livePm10}
                        unit="μg/m³"
                        pointer="PM 10"
                        fontColor={getColorCode(
                          webscocketIndoorData?.pm10
                            ? webscocketIndoorData?.pm10
                            : indoorData?.livePm10,
                          "PM10",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdpms == 0 ||
                            indoorSensorStatus?.asdpms == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        logo={Molecule}
                        websocketData={webscocketIndoorData?.tvoc}
                        dbRecentData={indoorData?.liveTvoc}
                        unit="μg/m³"
                        pointer="TVOC"
                        fontColor={getColorCode(
                          webscocketIndoorData?.tvoc
                            ? webscocketIndoorData?.tvoc
                            : indoorData?.liveTvoc,
                          "TVOC",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdtvoc == 0 ||
                            indoorSensorStatus?.asdtvoc == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        logo={Footprint}
                        websocketData={webscocketIndoorData?.co2}
                        dbRecentData={indoorData?.liveSo2}
                        unit="ppm"
                        pointer="CO2"
                        fontColor={getColorCode(
                          webscocketIndoorData?.co2
                            ? webscocketIndoorData?.co2
                            : indoorData?.liveSo2,
                          "CO2",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdco2 == 0 ||
                            indoorSensorStatus?.asdco2 == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        logo={Temprature}
                        websocketData={webscocketIndoorData?.temperature1}
                        dbRecentData={indoorData?.liveTemperature}
                        unit="C"
                        pointer="Temp"
                        fontColor={getColorCode(
                          webscocketIndoorData?.temperature1
                            ? webscocketIndoorData?.temperature1
                            : indoorData?.liveTemperature,
                          "TEMPERATURE1",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdowt == 0 ||
                            indoorSensorStatus?.asdowt == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        logo={Humidity}
                        websocketData={webscocketIndoorData?.humidity}
                        dbRecentData={indoorData?.liveRh}
                        unit="%"
                        pointer="RH"
                        fontColor={getColorCode(
                          webscocketIndoorData?.humidity
                            ? webscocketIndoorData?.humidity
                            : indoorData?.liveRh,
                          "rh",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdpms == 0 ||
                            indoorSensorStatus?.asdpms == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        logo={Footprint}
                        websocketData={webscocketIndoorData?.o2}
                        dbRecentData={indoorData?.liveO3}
                        unit="%"
                        pointer="O2"
                        fontColor={getColorCode(
                          webscocketIndoorData?.o2
                            ? webscocketIndoorData?.o2
                            : indoorData?.liveo3,
                          "o2",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdo2 == 0 ||
                            indoorSensorStatus?.asdo2 == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        logo={Ozone}
                        websocketData={webscocketIndoorData?.o3}
                        dbRecentData={indoorData?.liveO3}
                        unit="µg/m³"
                        pointer="O3"
                        fontColor={getColorCode(
                          webscocketIndoorData?.o3
                            ? webscocketIndoorData?.o3
                            : indoorData?.liveo3,
                          "o2",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdo3 == 0 ||
                            indoorSensorStatus?.asdo3 == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="µg/m³"
                        pointer="CO"
                        logo={Carbon}
                        websocketData={webscocketIndoorData?.co}
                        dbRecentData={indoorData?.liveCo}
                        fontColor={getColorCode(
                          webscocketIndoorData?.co
                            ? webscocketIndoorData?.co
                            : indoorData?.liveCo,
                          "co",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdmics == 0 ||
                            indoorSensorStatus?.asdmics == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="μg/m³"
                        pointer="NO2"
                        logo={Nitrogen}
                        websocketData={webscocketIndoorData?.no2}
                        dbRecentData={indoorData?.liveSo2}
                        fontColor={getColorCode(
                          webscocketIndoorData?.no2
                            ? webscocketIndoorData?.no2
                            : indoorData?.liveSo2,
                          "NO2",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdmics == 0 ||
                            indoorSensorStatus?.asdmics == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="μg/m³"
                        pointer="NH3"
                        logo={Ammonia}
                        websocketData={webscocketIndoorData?.nh3}
                        dbRecentData={indoorData?.liveNh3}
                        fontColor={getColorCode(
                          webscocketIndoorData?.nh3
                            ? webscocketIndoorData?.nh3
                            : indoorData?.liveNh3,
                          "NH3",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          indoorSensorStatus?.asdmics == 0 ||
                            indoorSensorStatus?.asdmics == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={12} className="text-end">
                      <span className="font-bold text-secondary font-14">
                        Last Restart Time -{" "}
                        {stationData?.lastIndoorRestartDate
                          ? moment(stationData?.lastIndoorRestartDate).format(
                            "DD-MM-yyyy h:mm a"
                          )
                          : ""}
                      </span>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col lg={6} sm={6}>
                <div className="white-card-box position-relative">
                  <div className="mb-2 d-flex justify-content-between align-items-center">
                    <strong>Outdoor Data</strong>
                    <img src={liveImage} width="38" alt="Logo" />

                    <Button
                      className="btn-sm"
                      type="submit"
                      id="save"
                      onClick={() => {
                        setRestartMAchineType("OUTDOOR");
                        setShowDelete(true);
                      }}
                    >
                      Restart
                    </Button>
                    {/* <FaRedoAlt
                      style={{
                        height: "18px",
                        width: "18px",
                        position: "absolute",
                        right: "10px",
                        cursor: "pointer",
                      }}
                      title="Restart"
                      onClick={handleOutdoorRestartData}
                    /> */}
                  </div>
                  <Row className="g-1">
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="µg/m³"
                        pointer="PM 1"
                        logo={Lungs}
                        websocketData={webSocketOutdoorData?.pm1}
                        dbRecentData={outdoorData?.livePm1}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.pm1
                            ? webSocketOutdoorData?.pm1
                            : outdoorData?.livePm1,
                          "PM1",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdpms == 0 ||
                            outdoorSensorStatus?.asdpms == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="μg/m³"
                        pointer="PM 2.5"
                        logo={Lungs}
                        websocketData={webSocketOutdoorData?.pm2_5}
                        dbRecentData={outdoorData?.livePm25}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.pm2_5
                            ? webSocketOutdoorData?.pm2_5
                            : outdoorData?.livePm25,
                          "pm2_5",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdpms == 0 ||
                            outdoorSensorStatus?.asdpms == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="μg/m³"
                        pointer="PM 10"
                        logo={Air}
                        websocketData={webSocketOutdoorData?.pm10}
                        dbRecentData={outdoorData?.livePm10}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.pm10
                            ? webSocketOutdoorData?.pm10
                            : outdoorData?.livePm10,
                          "PM10",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdpms == 0 ||
                            outdoorSensorStatus?.asdpms == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="µg/m³"
                        pointer="TVOC"
                        logo={Molecule}
                        websocketData={webSocketOutdoorData?.tvoc}
                        dbRecentData={outdoorData?.liveTvoc}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.tvoc
                            ? webSocketOutdoorData?.tvoc
                            : outdoorData?.liveTvoc,
                          "TVOC",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdtvoc == 0 ||
                            outdoorSensorStatus?.asdtvoc == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="ppm"
                        pointer="CO2"
                        logo={Footprint}
                        websocketData={webSocketOutdoorData?.co2}
                        dbRecentData={outdoorData?.liveSo2}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.co2
                            ? webSocketOutdoorData?.co2
                            : outdoorData?.liveSo2,
                          "CO2",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdco2 == 0 ||
                            outdoorSensorStatus?.asdco2 == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="C"
                        pointer="Temp"
                        logo={Temprature}
                        websocketData={webSocketOutdoorData?.temperature1}
                        dbRecentData={outdoorData?.liveTemperature}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.temperature1
                            ? webSocketOutdoorData?.temperature1
                            : outdoorData?.liveTemperature,
                          "TEMPERATURE1",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdowt == 0 ||
                            outdoorSensorStatus?.asdowt == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="%"
                        pointer="RH"
                        logo={Humidity}
                        websocketData={webSocketOutdoorData?.humidity}
                        dbRecentData={outdoorData?.liveRh}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.humidity
                            ? webSocketOutdoorData?.humidity
                            : outdoorData?.liveRh,
                          "rh",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asddht == 0 ||
                            outdoorSensorStatus?.asddht == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="%"
                        pointer="O2"
                        logo={Footprint}
                        websocketData={webSocketOutdoorData?.o2}
                        dbRecentData={outdoorData?.liveCo}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.o2
                            ? webSocketOutdoorData?.o2
                            : outdoorData?.liveCo,
                          "o2",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdo2 == 0 ||
                            outdoorSensorStatus?.asdo2 == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="µg/m³"
                        pointer="O3"
                        logo={Ozone}
                        websocketData={webSocketOutdoorData?.o3}
                        dbRecentData={outdoorData?.liveO3}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.o3
                            ? webSocketOutdoorData?.o3
                            : outdoorData?.liveO3,
                          "O3",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdo3 == 0 ||
                            outdoorSensorStatus?.asdo3 == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="µg/m³"
                        pointer="CO"
                        logo={Carbon}
                        websocketData={webSocketOutdoorData?.co}
                        dbRecentData={outdoorData?.liveCo}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.co
                            ? webSocketOutdoorData?.co
                            : outdoorData?.liveCo,
                          "CO",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdmics == 0 ||
                            outdoorSensorStatus?.asdmics == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="μg/m³"
                        pointer="NO2"
                        logo={Nitrogen}
                        websocketData={webSocketOutdoorData?.no2}
                        dbRecentData={outdoorData?.liveNo2}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.no2
                            ? webSocketOutdoorData?.no2
                            : outdoorData?.liveNo2,
                          "NO2",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdmics == 0 ||
                            outdoorSensorStatus?.asdmics == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={6} sm={6} xs={6}>
                      <Record
                        unit="μg/m³"
                        pointer="NH3"
                        logo={Ammonia}
                        websocketData={webSocketOutdoorData?.nh3}
                        dbRecentData={outdoorData?.liveNh3}
                        fontColor={getColorCode(
                          webSocketOutdoorData?.nh3
                            ? webSocketOutdoorData?.nh3
                            : outdoorData?.liveNh3,
                          "NH3",
                          stationParameterRangeData
                        )}
                        backgroundColor={
                          outdoorSensorStatus?.asdmics == 0 ||
                            outdoorSensorStatus?.asdmics == -1
                            ? "#efddde"
                            : ""
                        }
                      />
                    </Col>
                    <Col lg={12} className="text-end">
                      <span className="font-bold text-secondary font-14">
                        Last Restart Time -{" "}
                        {stationData?.lastOutdoorRestartDate
                          ? moment(stationData?.lastOutdoorRestartDate).format(
                            "DD-MM-yyyy h:mm a"
                          )
                          : ""}
                      </span>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
          <Col lg={7} sm={7}>
            <Row className="g-3">
              <Col lg={6} sm={6}>
                <div className="white-card-box" style={{ height: "235px" }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5 className="h5-title">
                        Recent data from Machine{" "}
                        {
                          machineData && machineData?.dateTime && (
                            <img src={liveImage} width="38" alt="Logo" />
                          )
                        }
                      </h5>
                    </div>
                    {/* <div className="dates ms-auto">
                      {machineData && machineData?.dateTime ? (
                        <>
                          {" "}
                          <span className="text-secondary font-bold">
                            {moment(indoorData?.dateTime).isValid()
                              ? `Date & Time : ${moment(
                                indoorData?.dateTime
                              ).format("DD-MM-YYYY hh:mm A")}`
                              : ""}
                          </span>
                        </>
                      ) : (
                        ""
                      )}
                    </div> */}
                    <div className="dates ms-auto">
                      {machineData && machineData?.dateTime ? (
                        <span>
                          Date & Time :{" "}
                          {moment(indoorData?.dateTime).format("DD-MM-YYYY hh:mm A")}
                        </span>
                      ) : liveMachineData?.liveMachineDataResponse?.createdDate ? (
                        <span>
                          Date & Time :{" "}
                          {moment(liveMachineData?.liveMachineDataResponse?.createdDate).format(
                            "DD-MM-YYYY hh:mm A"
                          )}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="brderBtm"></div>
                  <Row className="g-3 mb-2">
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">Moisture Lvl.</span>
                      <br />
                      <span className="sub-titles">
                        {machineData?.moistureLevel
                          ? machineData?.moistureLevel
                          : liveMachineData?.liveMachineDataResponse?.moistureLevel
                            ? liveMachineData?.liveMachineDataResponse?.moistureLevel
                            : 0}
                      </span>
                    </Col>
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">Water Lvl.</span>
                      <br />
                      <span className="sub-titles">
                        {machineData?.waterLevel ? machineData?.waterLevel : liveMachineData?.liveMachineDataResponse?.tankWaterLevel
                          ? liveMachineData?.liveMachineDataResponse?.tankWaterLevel
                          : 0}
                      </span>
                    </Col>
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">PM1</span>
                      <br />
                      <span className="sub-titles">
                        {machineData?.pm1 ? machineData?.pm1 : liveMachineData?.liveMachineDataResponse?.pm1
                          ? liveMachineData?.liveMachineDataResponse?.pm1
                          : 0}
                      </span>
                    </Col>
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">PM2.5</span>
                      <br />
                      <span className="sub-titles">
                        {machineData?.pm2_5 ? machineData?.pm2_5 : liveMachineData?.liveMachineDataResponse?.pm25
                          ? liveMachineData?.liveMachineDataResponse?.pm25
                          : 0}
                      </span>
                    </Col>
                  </Row>
                  <Row className="g-3 mb-2">
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">PM10</span>
                      <br />
                      <span className="sub-titles">
                        {machineData?.pm10 ? machineData?.pm10 : liveMachineData?.liveMachineDataResponse?.pm10
                          ? liveMachineData?.liveMachineDataResponse?.pm10
                          : 0}
                      </span>
                    </Col>
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">Temp.</span>{" "}
                      {/* Temperature */}
                      <br />
                      <span className="sub-titles">
                        {machineData?.temperature ? machineData?.temperature?.toFixed(2) : liveMachineData?.liveMachineDataResponse?.temperature
                          ? liveMachineData?.liveMachineDataResponse?.temperature?.toFixed(2)
                          : 0}
                      </span>
                    </Col>
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">Humidity</span>
                      <br />
                      <span className="sub-titles">
                        {machineData?.humidity ? machineData?.humidity?.toFixed(2) : liveMachineData?.liveMachineDataResponse?.rh
                          ? liveMachineData?.liveMachineDataResponse?.rh?.toFixed(2)
                          : 0}
                      </span>
                    </Col>
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">Lux</span>
                      <br />
                      <span className="sub-titles">
                        {machineData?.lux ? machineData?.lux?.toFixed(2) : liveMachineData?.liveMachineDataResponse?.lux
                          ? liveMachineData?.liveMachineDataResponse?.lux?.toFixed(2)
                          : 0}
                      </span>
                    </Col>
                  </Row>
                  <Row className="g-3">
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">Decibel</span>
                      <br />
                      <span className="sub-titles">{machineData?.db ? machineData?.db : liveMachineData?.liveMachineDataResponse?.db
                        ? liveMachineData?.liveMachineDataResponse?.db
                        : 0}</span>
                    </Col>
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">Battery Lvl.</span>
                      <br />
                      <span className="sub-titles">
                        {machineData?.battery ? machineData?.battery : liveMachineData?.liveMachineDataResponse?.batteryLevel
                          ? liveMachineData?.liveMachineDataResponse?.batteryLevel
                          : 0}
                      </span>
                    </Col>
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">Current</span>
                      <br />
                      <span className="sub-titles">
                        {machineData?.amp ? machineData?.amp : liveMachineData?.liveMachineDataResponse?.current
                          ? liveMachineData?.liveMachineDataResponse?.current
                          : 0}
                      </span>
                    </Col>
                    <Col lg={3} sm={3} xs={6}>
                      <span className="main-titles">Voltage</span>
                      <br />
                      <span className="sub-titles">
                        {machineData?.volt ? machineData?.volt : liveMachineData?.liveMachineDataResponse?.voltage
                          ? liveMachineData?.liveMachineDataResponse?.voltage
                          : 0}
                      </span>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col lg={6} sm={6}>
                <div className="white-card-box">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <h5 className="h5-title">
                        Recent data from Airscope{" "}
                        {
                          webscocketIndoorData &&
                          webscocketIndoorData?.dateTime && (
                            <img src={liveImage} width="38" alt="Logo" />
                          )
                        }
                      </h5>
                    </div>
                    {/* <div className="dates ms-auto">
                      {webscocketIndoorData &&
                        webscocketIndoorData?.dateTime ? (
                        <>
                          {" "}
                          <span>
                            Date & Time :
                            {moment(indoorData?.dateTime).format(
                              "DD-MM-YYYY hh:mm A"
                            )}
                          </span>
                        </>
                      ) : (
                        <>
                          {" "}
                          <span>
                            Date & Time :
                            {moment(liveMachineData?.liveAirscopeDataResponse?.createdDate).format(
                              "DD-MM-YYYY hh:mm A"
                            )}
                          </span>
                        </>
                      )}
                    </div> */}
                    <div className="dates ms-auto">
                      {webscocketIndoorData && webscocketIndoorData?.dateTime ? (
                        <span>
                          Date & Time :{" "}
                          {moment(indoorData?.dateTime).format("DD-MM-YYYY hh:mm A")}
                        </span>
                      ) : liveMachineData?.liveAirscopeDataResponse?.createdDate ? (
                        <span>
                          Date & Time :{" "}
                          {moment(liveMachineData?.liveAirscopeDataResponse?.createdDate).format(
                            "DD-MM-YYYY hh:mm A"
                          )}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="brderBtm"></div>
                  <Row className="g-3 mb-2">
                    <Col>
                      <span className="main-titles">PM1</span>
                      <br />
                      <span className="sub-titles">
                        {webscocketIndoorData?.pm1 ? Number(webscocketIndoorData.pm1).toFixed(2) : liveMachineData?.liveAirscopeDataResponse?.pm1
                          ? Number(liveMachineData.liveAirscopeDataResponse.pm1).toFixed(2)
                          : 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">PM2.5</span>
                      <br />
                      <span className="sub-titles">
                        {webscocketIndoorData?.pm2_5 ? Number(webscocketIndoorData?.pm2_5).toFixed(2) : liveMachineData?.liveAirscopeDataResponse?.pm2_5
                          ? Number(liveMachineData?.liveAirscopeDataResponse?.pm2_5).toFixed(2)
                          : 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">PM10</span>
                      <br />
                      <span className="sub-titles">
                        {webscocketIndoorData?.pm10 ? Number(webscocketIndoorData?.pm10).toFixed(2) : liveMachineData?.liveAirscopeDataResponse?.pm10
                          ? Number(liveMachineData?.liveAirscopeDataResponse?.pm10).toFixed(2)
                          : 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">Temp. 1</span>
                      <br />
                      <span className="sub-titles">
                        {webscocketIndoorData?.temperature1 ? Number(webscocketIndoorData?.temperature1).toFixed(2) : liveMachineData?.liveAirscopeDataResponse?.temperature1
                          ? Number(liveMachineData?.liveAirscopeDataResponse?.temperature1).toFixed(2)
                          : 0}{" "}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">NH3</span>
                      <br />
                      <span className="sub-titles">
                        {/* {webscocketIndoorData?.nh3 ? webscocketIndoorData?.nh3 : liveMachineData?.liveAirscopeDataResponse?.nh3
                          ? liveMachineData?.liveAirscopeDataResponse?.nh3
                          : 0} */}
                        {webscocketIndoorData?.nh3 ?? liveMachineData?.liveAirscopeDataResponse?.nh3 ?? 0}
                      </span>
                    </Col>
                  </Row>
                  <Row className="g-3 mb-2">
                    <Col>
                      <span className="main-titles">O2</span>
                      <br />
                      <span className="sub-titles">
                        {webscocketIndoorData?.o2 ? Number(webscocketIndoorData?.o2).toFixed(2) : liveMachineData?.liveAirscopeDataResponse?.o2
                          ? Number(liveMachineData?.liveAirscopeDataResponse?.o2).toFixed(2)
                          : 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">Temp. 2</span>
                      <br />
                      <span className="sub-titles">
                        {webscocketIndoorData?.temperature2 ? Number(webscocketIndoorData?.temperature2).toFixed(2) : liveMachineData?.liveAirscopeDataResponse?.temperature2
                          ? Number(liveMachineData?.liveAirscopeDataResponse?.temperature2).toFixed(2)
                          : 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">Humidity</span>
                      <br />
                      <span className="sub-titles">
                        {webscocketIndoorData?.humidity ? Number(webscocketIndoorData?.humidity).toFixed(2) : liveMachineData?.liveAirscopeDataResponse?.rh
                          ? Number(liveMachineData?.liveAirscopeDataResponse?.rh).toFixed(2)
                          : 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">TVOC</span>
                      <br />
                      <span className="sub-titles">
                        {webscocketIndoorData?.tvoc ? Number(webscocketIndoorData?.tvoc).toFixed(2) : liveMachineData?.liveAirscopeDataResponse?.tvoc
                          ? Number(liveMachineData?.liveAirscopeDataResponse?.tvoc).toFixed(2)
                          : 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">Decibel</span>
                      <br />
                      <span className="sub-titles">
                        {webscocketIndoorData?.decibel ||
                          webscocketIndoorData?.db ||
                          liveMachineData?.liveAirscopeDataResponse?.db
                          ? Number(liveMachineData?.liveAirscopeDataResponse?.db).toFixed(2)
                          : 0}
                      </span>
                    </Col>
                  </Row>
                  <Row className="g-3">
                    <Col>
                      <span className="main-titles">CO2</span>
                      <br />
                      <span className="sub-titles">
                        {/* {webscocketIndoorData?.co2 ? webscocketIndoorData?.co2 : liveMachineData?.liveAirscopeDataResponse?.co2
                          ? liveMachineData?.liveAirscopeDataResponse?.co2
                          : 0} */}
                        {webscocketIndoorData?.co2 ?? liveMachineData?.liveAirscopeDataResponse?.co2 ?? 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">O3</span>
                      <br />
                      <span className="sub-titles">

                        {webscocketIndoorData?.o3 ?? liveMachineData?.liveAirscopeDataResponse?.o3 ?? 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">CO</span>
                      <br />
                      <span className="sub-titles">

                        {webscocketIndoorData?.co ?? liveMachineData?.liveAirscopeDataResponse?.co ?? 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">NO2</span>
                      <br />
                      <span className="sub-titles">
                        {/* {webscocketIndoorData?.no2 ? webscocketIndoorData?.no2 : liveMachineData?.liveAirscopeDataResponse?.no2
                          ? liveMachineData?.liveAirscopeDataResponse?.no2
                          : 0} */}
                        {webscocketIndoorData?.no2 ?? liveMachineData?.liveAirscopeDataResponse?.no2 ?? 0}
                      </span>
                    </Col>
                    <Col>
                      <span className="main-titles">Lux</span>
                      <br />
                      <span className="sub-titles">
                        {webscocketIndoorData?.luxlevel ||
                          webscocketIndoorData?.lux ||
                          liveMachineData?.liveAirscopeDataResponse?.lux
                          ? Number(liveMachineData?.liveAirscopeDataResponse?.lux).toFixed(2)
                          : 0}
                      </span>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col lg={12} sm={12} className="mt-3">
                <div className="white-card-box" style={{ height: "235px" }}>
                  <Row>
                    <Col lg={3} sm={3}>
                      <div
                        style={{ background: "#F4F4F4" }}
                        onClick={() => {
                          setModalShow(true);
                          setIsChartView(false);
                        }}
                      >
                        <img
                          src={stationData?.stationImage || Fridgesimg}
                          alt=""
                          width={"100%"}
                          style={{
                            padding: "10px",
                            height: "160px",
                            objectFit: "contain",
                            width: "100%",
                          }}
                        />
                      </div>
                    </Col>
                    <Col lg={9} sm={9}>
                      <Row className="g-3 mb-2">
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Leaf Guardian</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.leafGuardian || "-"}
                          </span>
                        </Col>
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Last Water Filled</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.lastWaterFilled
                              ? moment(stationData?.lastWaterFilled).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </span>
                        </Col>
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Station Mode</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.stationMode || "-"}
                          </span>
                        </Col>
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Location</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.location || "-"}
                          </span>
                        </Col>
                      </Row>
                      <Row className="g-3 mb-2">
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Last Service Date</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.lastServiceDate
                              ? moment(stationData?.lastServiceDate).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </span>
                          {/* <span className="sub-titles">
                            {stationData?.lastServiceDate
                              ? moment(stationData?.lastServiceDate).format(
                                  "DD-MM-YYYY"
                                )
                              : "-"}
                          </span> */}
                        </Col>
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Last Irrigation</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.lastIrrigationDate
                              ? moment(stationData?.lastIrrigationDate).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </span>
                        </Col>
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Irrigation Delay</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.irrDelay
                              ? stationData?.irrDelay + " sec"
                              : "-"}
                          </span>
                        </Col>
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Tag</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.tag || "-"}
                          </span>
                        </Col>
                      </Row>
                      <Row className="g-3">
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Next Service Date</span>
                          <br />
                          <span
                            className={`sub-titles ${HelperService.isPastDate(
                              stationData?.nextServiceDate
                            )
                              ? "text-danger font-bold"
                              : ""
                              }`}
                          >
                            {stationData?.nextServiceDate
                              ? moment(stationData?.nextServiceDate).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </span>
                        </Col>

                        {/* <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Building</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.building || "-"}
                          </span>
                        </Col> */}
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Client Name</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.clientName || "-"}
                          </span>
                        </Col>
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Station Name</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.stationName || "-"}
                          </span>
                        </Col>
                        <Col lg={3} sm={3} xs={6}>
                          <span className="main-titles">Machine ID</span>
                          <br />
                          <span className="sub-titles">
                            {stationData?.machineId || "-"}
                          </span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="g-3 mt-0">
          <Col lg={6} sm={6} className="mb-3 ">
            <div className="white-card-box py-3 commandcenterbox">
              <Row>
                <Col lg={12} className="text-center font-bold font-16">
                  <p>
                    {PM25IndoorObject?.parameter
                      ? formatOutdoorLabel(PM25IndoorObject?.parameter)
                      : ""}
                  </p>
                </Col>
                <Col lg={6} sm={6}>
                  <div className="boxshadow p-2 pb-0">
                    <center className=" mb-2">
                      <Meter data={PM25IndoorObject} key={key} />
                      <div
                        className="d-flex justify-content-between"
                        style={{ marginTop: "0px" }}
                      >
                        <div className="text-center">
                          {" "}
                          <p className="mb-0 ms-4 me-4"></p>
                        </div>
                        <div>
                          {PM25IndoorObject?.label ? (
                            <div
                              style={{
                                background:
                                  PM25IndoorObject?.badgeClass || "#cc3232",
                                borderRadius: "10px",
                                marginTop: "-10px",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                              className="font-10 font-bold d-flex align-items-center justify-content-center mt-0 col-12 px-0 me-2 mx-auto slowveryfase"
                            >
                              {PM25IndoorObject?.emoji}
                              {PM25IndoorObject?.label}
                            </div>
                          ) : null}
                        </div>

                        <div>
                          {" "}
                          <b className="font-14">(Indoor)</b>
                        </div>
                      </div>
                    </center>
                  </div>
                </Col>
                <Col lg={6} sm={6}>
                  <div className="boxshadow p-2 pb-0 ">
                    <center className="mb-2">
                      {/* <b className="font-16">(Outdoor)</b> */}
                      <Meter data={PM25OutdoorObject} key={key1} />
                      <div
                        className="d-flex justify-content-between"
                        style={{ marginTop: "0px" }}
                      >
                        <div>
                          {" "}
                          <p className="mb-0 ms-4 me-4"></p>
                        </div>
                        <div>
                          {PM25OutdoorObject?.label ? (
                            <div
                              style={{
                                background:
                                  PM25OutdoorObject?.badgeClass || "#cc3232",
                                borderRadius: "10px",
                                marginTop: "-12px",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                              className={`font-10 font-bold d-flex align-items-center justify-content-center mt-1 col-12 mx-auto me-3 slowveryfase`}
                            >
                              {PM25OutdoorObject?.emoji}
                              {PM25OutdoorObject?.label}
                            </div>
                          ) : null}
                        </div>
                        <div>
                          {" "}
                          <b className="font-14">(Outdoor)</b>
                        </div>
                      </div>
                    </center>
                  </div>
                </Col>
                <Col lg={12} className="d-flex justify-content-center">
                  {PM25IndoorObject && PM25IndoorObject?.text && (
                    <div className="d-flex">
                      <div className="indoorair d-flex gap-2 p-1 mt-2 w-100">
                        <div className="me-2">
                          <img src={AirText} width="30" alt="Logo" />
                        </div>
                        <div className="font-14 my-auto">
                          {PM25IndoorObject &&
                            PM25IndoorObject?.parameter &&
                            `Live Indoor
                          ${PM25IndoorObject?.parameter === "pm2_5"
                              ? "PM 2.5"
                              : PM25IndoorObject?.parameter.toLocaleUpperCase()
                            } vs Outdoor                     
                            ${PM25IndoorObject?.parameter === "pm2_5"
                              ? "PM 2.5"
                              : PM25IndoorObject?.parameter.toLocaleUpperCase()
                            }`}
                          {/* Indoor air quality is more better than the Outdoor */}
                          {/* {PM25IndoorObject && PM25IndoorObject?.label !==  PM25OutdoorObject?.label&&  PM25IndoorObject?.text} */}
                        </div>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Col>
          <Col lg={4} sm={4}>
            <div className="white-card-box py-4 commandcenterbox">
              <div className="d-flex align-items-center justify-content-between">
                <div className="col-2">
                  <span
                    style={{
                      display: "inline-block",
                      width: "10px",
                      height: "10px",
                      backgroundColor: "#32CD32",
                      marginRight: "5px",
                    }}
                  ></span>
                  <span className="font-bold font-12">Indoor</span>
                  <br />
                  <span
                    style={{
                      display: "inline-block",
                      width: "10px",
                      height: "10px",
                      backgroundColor: "#FFA500",
                      marginRight: "5px",
                    }}
                  ></span>
                  <span className="font-bold font-10">Outdoor</span>
                </div>
                <div className="col-8 text-center">
                  <span className="text-text-nowrap font-12 font-bold ">
                    {selectedValue?.label}- Indoor Vs. Outdoor
                  </span>
                </div>

                <div>
                  <select
                    id="parameterDropdown"
                    style={{ width: "70px" }}
                    value={selectedValue.value}
                    className="form-control "
                    onChange={handleDropdownChange}
                  >
                    {dropdownValues.map((param: any) => (
                      <option key={param.value} value={param.value}>
                        {param.label}
                      </option>
                    ))}
                  </select>{" "}
                </div>
              </div>
              <div className="py-2">
                {modalShow && (
                  <FullScreenChart
                    show={modalShow}
                    src={stationData?.stationImage || Fridgesimg}
                    outdoorOptionGraphData={chartData}
                    isChartView={isChartView}
                    onHide={() => setModalShow(false)}
                    selectedLabel={selectedValue?.label}
                  />
                )}
                {hasData ? (
                  chartData && (
                    <React.Fragment>
                      <div>
                        <ReactECharts
                          option={chartData}
                          className="react-charts-height"
                        />
                      </div>
                      <div
                        className=" d-flex justify-content-end"
                        onClick={() => {
                          setModalShow(true);
                          setIsChartView(true);
                        }}
                      >
                        <HiMiniViewfinderCircle size={25} />
                      </div>
                    </React.Fragment>
                  )
                ) : (
                  <div
                    className="text-center text-muted"
                    style={{ padding: "50px" }}
                  >
                    <h5>No data available for selected parameter.</h5>
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col lg={2} sm={2}>
            <div className="white-card-box py-4 pb-3 commandcenterbox">
              <div
                className="boxshadow1 weatherbg p-3 h-100"
                style={{ height: "200px" }}
              >
                <div className="d-flex align-items-center my-2 h-100 row">
                  <Col lg={7} className="pe-0 d-flex align-items-center">
                    <div className="weather py-2">
                      <h5 className="mb-1 text">
                        {" "}
                        {weatherData && weatherData?.temperature}°C
                      </h5>
                      <p className="mb-0 font-400 font-12 text-dark">
                        Hello, {weatherData && weatherData?.city}!
                      </p>
                    </div>
                  </Col>
                  <Col lg={5} className="text-center">
                    <h5 className="mb-1">
                      <img src={Sun} alt="Logo" width="30" />
                    </h5>
                    <p className="font-12 mb-0 font-400">
                      {weatherData && weatherData?.weatherDiscription}
                    </p>
                  </Col>
                </div>
              </div>
              <div className="brderBtm"></div>
              <div className="d-flex justify-content-between aling-items-center">
                <div className="font-10">
                  <span className="font-bold">
                    Dominant
                    <br />
                    Pollutant
                  </span>{" "}
                  (Indoor)
                </div>
                <div>
                  <img src={OzoneLayero3} alt="" />{" "}
                  <span className="font-12" style={{ color: "#278C5D" }}>
                    ({dominantPollutant})
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <Modal show={showDelete} onHide={handleCloseDelete} centered>
        <Modal.Header
          closeButton
          onClick={handleCloseDelete}
          className=" border-0 pb-0"
        ></Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <h2 className="text-danger">
              <PiSealWarning size={70} />
            </h2>
            <h4 className="font-18">
              Are you sure you want to restart machine?
            </h4>
          </div>
        </Modal.Body>
        <Modal.Footer className=" justify-content-center border-0 pt-0 mb-2">
          <button className="btn btn-danger w-25 " onClick={handleCloseDelete}>
            No
          </button>
          <Button
            className="btn-brand-1 w-25"
            onClick={handleRestartMachine}
            id="save11"
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {relayScreen && (
        <Modal
          show={relayScreen}
          onHide={() => setRelayScreen(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {t("Relay")}
            </Modal.Title>
          </Modal.Header>
          <Form
            className="wmx-form-style"
            name="relay"
            id="relay"
            onSubmit={handleSubmit1(handleSave)}
          >
            <Modal.Body style={{ height: "500px", overflowY: "scroll" }}>
              <div className="table-card table-responsive">
                <Card className="table-container">
                  <Table className="table-style">
                    <thead>
                      <tr>
                        <th style={{ cursor: "pointer" }}>Relay</th>
                        <th>Flow Enabled</th>
                        <th>Manual Triggered</th>
                        <th>Machine Status</th>
                        <th>Relay Component</th>
                      </tr>
                    </thead>
                    <tbody>
                      {relayList?.length > 0 ? (
                        relayList?.map((list: any, index: any) => {
                          return (
                            <tr key={index}>
                              <td>{list?.relayName}</td>
                              <td>
                                <div>
                                  <Form.Check
                                    type="switch"
                                    id={list?.id}
                                    defaultChecked={list?.enabled === true}
                                    className="labe-text-dark checkbox-success"
                                    onChange={(e: any) => {
                                      onEnabledSelect(
                                        e.target.checked,
                                        list?.id
                                      );
                                    }}
                                  />
                                </div>
                              </td>

                              <td>
                                {list.relayName === "relay1Regulate" ||
                                  list.relayName === "relay2Regulate" ? (
                                  <div>
                                    <input
                                      style={{ width: "70px" }}
                                      type="number"
                                      value={list.relayValue || ""}
                                      onChange={(e) => {
                                        var value = Number(e.target.value);
                                        if (
                                          !isNaN(value) &&
                                          value >= 0 &&
                                          value <= 100
                                        ) {
                                          handleInputChange(
                                            e.target.value,
                                            list?.id
                                          );
                                        }
                                      }}
                                    />
                                  </div>
                                ) : !list.relayName.includes("moisture") &&
                                  !list.relayName.includes("waterLevel") &&
                                  !list.relayName.includes("pms7003") &&
                                  !list.relayName.includes("dht22") &&
                                  !list.relayName.includes("lux") &&
                                  !list.relayName.includes("db") &&
                                  !list.relayName.includes("powerMonitor") &&
                                  !list.relayName.includes("relayBoard") ? (
                                  <div>
                                    <Form.Check
                                      type="switch"
                                      id={list?.id}
                                      defaultChecked={
                                        list?.machineStatus === 1 ? true : false
                                      }
                                      className="labe-text-dark checkbox-success"
                                      onChange={(e) =>
                                        onWorkingSelect(
                                          e.target.checked,
                                          list?.id
                                        )
                                      }
                                    />
                                  </div>
                                ) : null}
                              </td>

                              <td>
                                {list.relayName === "relay10" ||
                                  list.relayName === "relay9" ? (
                                  ""
                                ) : (
                                  <div
                                    className={`circle ${getColorClass(
                                      list?.machineStatus
                                    )}`}
                                  />
                                )}
                              </td>
                              <td>
                                {list.relayName.startsWith("relay") &&
                                  !list.relayName.includes("Board") &&
                                  !list.relayName.includes("moisture") &&
                                  !list.relayName.includes("waterLevel") &&
                                  !list.relayName.includes("pms7003") &&
                                  !list.relayName.includes("dht22") &&
                                  !list.relayName.includes("lux") &&
                                  !list.relayName.includes("db") &&
                                  !list.relayName.includes("powerMonitor") ? (
                                  list.relayName.includes("Regulate") ? (
                                    <div className="form-group">
                                      <AsyncSelect
                                        key={index}
                                        ref={participantRefRegulate}
                                        defaultOptions={getAvailableOptionsRegulate(
                                          index
                                        )}
                                        cacheOptions
                                        loadOptions={
                                          participantPromiseOptionsRegulate
                                        }
                                        onChange={(selectedOption) =>
                                          onParticipantSelectionRegulate(
                                            selectedOption,
                                            index,
                                            list.id
                                          )
                                        }
                                        isSearchable={false}
                                        placeholder="Select Type"
                                        value={
                                          selectedParticipantsRegulate[index]
                                        }
                                        isClearable={true}
                                        defaultValue={
                                          list.relayCode
                                            ? {
                                              value: list.relayCode,
                                              label: list.relayCode,
                                            }
                                            : ""
                                        }
                                        isDisabled={
                                          list.relayName === "relay10" ||
                                          list.relayName === "relay9"
                                        }
                                      />
                                    </div>
                                  ) : (
                                    <div className="form-group">
                                      <AsyncSelect
                                        key={"relay_" + index}
                                        ref={participantRef}
                                        defaultOptions={getAvailableOptions(
                                          index
                                        )}
                                        cacheOptions
                                        loadOptions={participantPromiseOptions}
                                        onChange={(selectedOption) =>
                                          onParticipantSelection(
                                            selectedOption,
                                            index,
                                            list.id
                                          )
                                        }
                                        isSearchable={false}
                                        placeholder="Select Type"
                                        value={selectedParticipants[index]}
                                        isClearable={true}
                                        defaultValue={
                                          list.relayCode
                                            ? {
                                              value: list.relayCode,
                                              label: list.relayCode,
                                            }
                                            : ""
                                        }
                                        isDisabled={
                                          list.relayName === "relay10" ||
                                          list.relayName === "relay9"
                                        }
                                      />
                                    </div>
                                  )
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td></td>
                          <td>
                            <div className="table-wrap position-relative text-centre">
                              <div className="no-data-flound">
                                <div className="">
                                  <img
                                    src={NoDataFound}
                                    width={110}
                                    className="mb-3 text-centre"
                                  />
                                  <h3 className="text-secondary font-12">
                                    No Record Found
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td></td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Card>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setRelayScreen(false)}>
                <MdClose size={18} className="icon" />
                &nbsp; {t("cancel")}
              </Button>
              <Button variant="primary" type="submit" id="saveRelay">
                <BsSave size={18} className="icon" />
                &nbsp; {t("save")}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </>
  );
};
export default CommandCentreNewFlow;
